import React, { useEffect, useState } from "react";

const Calendly = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const existing = document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]');
    if (existing) {
      setLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    script.onload = () => setLoaded(true);
    document.body.appendChild(script);

    return () => {};
  }, []);

  return (
    <div className="w-full overflow-x-hidden bg-white">
      <section className="relative w-full overflow-hidden bg-[color:var(--navy)]">
        <div className="absolute inset-0">
          <div className="absolute -top-44 -right-44 h-[32rem] w-[32rem] rounded-full bg-[color:var(--brand-accent)]/22 blur-3xl" />
          <div className="absolute -bottom-52 -left-52 h-[36rem] w-[36rem] rounded-full bg-[color:var(--brand)]/26 blur-3xl" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/25 to-black/55" />
        </div>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-18 sm:py-20">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-white">
              Booking
              <span className="h-1.5 w-1.5 rounded-full bg-[color:var(--brand-accent)]" />
              Schedule a call
            </div>

            <h1 className="mt-6 text-4xl sm:text-5xl font-semibold tracking-tight text-white">
              Book a session with our team
            </h1>

            <p className="mt-5 text-base sm:text-lg text-white/85 max-w-2xl">
              Choose a time that works best. We’ll use the call to understand goals, constraints, and recommend next steps.
            </p>
          </div>
        </div>
      </section>

      <section className="relative w-full overflow-hidden bg-white">
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
          <div className="absolute -top-44 -right-44 h-[30rem] w-[30rem] rounded-full bg-[color:var(--brand-accent)]/10 blur-3xl" />
          <div className="absolute -bottom-52 -left-52 h-[36rem] w-[36rem] rounded-full bg-[color:var(--brand)]/10 blur-3xl" />
        </div>

        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 sm:py-16">
          <div className="rounded-2xl border border-[color:var(--border)] bg-[color:var(--surface)] p-4 sm:p-6">
            {!loaded && (
              <div className="flex items-center justify-center rounded-2xl bg-white py-16">
                <div className="text-sm font-semibold text-[color:var(--muted)]">
                  Loading booking calendar...
                </div>
              </div>
            )}

            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/hemanthkammili00/30min"
              style={{ minWidth: "320px", height: "820px", display: loaded ? "block" : "none" }}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Calendly;
